import React from 'react'
import { documentStateLabel } from '../../utils/display_names'
import { formatTimeString } from '../../utils/formatters'
import { getImageSrc } from '../../utils/images'

const IdDocumentTrImage = ({ entry, handleClick }) => (
  <tr key={entry.id}>
    <td>{entry.id}</td>
    <td>
      <div className='netki-preview-landscape'>
        <img alt='document' style={{ cursor: 'pointer' }} onClick={handleClick} src={getImageSrc(entry)} />
      </div>
    </td>
    <td>{entry.document_type && entry.document_type.toUpperCase()}</td>
    <td>{entry.is_active ? 'Yes' : 'No'}</td>
    <td>{documentStateLabel(entry.state).toUpperCase()}</td>
    <td>{formatTimeString(entry.created)}</td>
    <td>{formatTimeString(entry.updated)}</td>
  </tr>
)

export default IdDocumentTrImage
